<div class="switch-container">
  <label [ngClass]="{'enabled': isEnabled}" class="switch">
    <input (change)="onChange($event)" [checked]="isEnabled" type="checkbox">
    <span class="slider"></span>
  </label>
</div>